module.exports = __webpack_public_path__ + "img/Grant_B_Circle.8ba62ed2.png";